export const ru = {
    'agency:': 'Представитель агентства:',
    'manager:': 'Менеджер:'
};
